import React from "react";
import Button from "../../components/button";
import ReadOnlyField from "../../components/readOnlyField";

interface AccessSettingsSectionProps {
  title: string;
  role?: string;
  branch?: string;
  showActions?: boolean;
  actionPrimaryLabel?: string;
  actionSecondaryLabel?: string;
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
  disablePrimaryAction?: boolean;
  disableSecondaryAction?: boolean;
  labels: {
    role: string;
    branch: string;
  };
}

const AccessSettingsSection: React.FC<AccessSettingsSectionProps> = ({
  title,
  role,
  branch,
  showActions = false,
  actionPrimaryLabel,
  actionSecondaryLabel,
  onPrimaryAction,
  onSecondaryAction,
  disablePrimaryAction = false,
  disableSecondaryAction = false,
  labels,
}) => {
  return (
    <div className="flex flex-col lg:flex-row gap-4 lg:gap-6">
      <div className="lg:w-48 flex-shrink-0">
        <h2 className="text-sm font-medium text-[#414651] mb-4 lg:mb-0">
          {title}
        </h2>
      </div>
      <div className="flex-1 rounded-xl border border-[#E9EAEB] bg-white shadow-sm">
        <div className="px-4 sm:px-6 py-6">
          <div className="grid grid-cols-1 gap-4">
            <ReadOnlyField label={labels.role} value={role} />
            <ReadOnlyField label={labels.branch} value={branch} />
          </div>
        </div>

        {showActions && (
          <div className="flex flex-col gap-3 border-t border-[#E9EAEB] px-4 sm:px-6 py-4 sm:flex-row sm:justify-end sm:gap-4">
            <Button
              variant="white"
              className="w-full sm:w-auto"
              onClick={onSecondaryAction}
              disabled={disableSecondaryAction}
            >
              {actionSecondaryLabel}
            </Button>
            <Button
              variant="primary"
              className="w-full sm:w-auto"
              onClick={onPrimaryAction}
              disabled={disablePrimaryAction}
            >
              {actionPrimaryLabel}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccessSettingsSection;
